import apiClient from "./apiClient";
import { PROFILE_ENDPOINT } from "../constants/endpoints";

const ProfileService = {
    /**
     * Fetch student information
     * @returns {Promise} Axios response
     */
    getStudentInfo: async () => {
        return await apiClient.get(PROFILE_ENDPOINT.GET_INFO, {
            skipAuthRedirect: true
        });
    },

    /**
     * Update profile photo
     * @param {FormData} formData - Contains the image file
     * @returns {Promise} Axios response
     */
    updateProfilePhoto: async (formData) => {
        return await apiClient.post(PROFILE_ENDPOINT.UPLOAD_IMAGE, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    /**
     * Update password
     * @param {Object} payload - { old_password, new_password, new_password_confirmation }
     * @returns {Promise} Axios response
     */
    updatePassword: async (payload) => {
        return await apiClient.post(PROFILE_ENDPOINT.UPDATE_PASSWORD, payload);
    },
};

export default ProfileService;
